// import '@coreui/icons/css/coreui-icons.min.css';
// // Import Flag Icons Set
// import 'flag-icon-css/css/flag-icon.min.css';
// // Import Font Awesome Icons Set
import 'font-awesome/css/font-awesome.min.css';
// Import Simple Line Icons Set
import 'simple-line-icons/css/simple-line-icons.css';

export { RXForm } from "./RXForm";
export { RXModalForm } from "./RXModalForm";
export { RXModalSize, RXModalColor } from '@radixnpm/rx-core';

// module.exports = {
//     RXForm: RXForm,
//     RXModalForm: RXModalForm,
//     RXModalColor: RXModalColor,
//     RXModalSize: RXModalSize
// };